import { render, staticRenderFns } from "./AddEditActiveStudent.vue?vue&type=template&id=4b4e55d6&scoped=true"
import script from "./AddEditActiveStudent.vue?vue&type=script&lang=js"
export * from "./AddEditActiveStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e55d6",
  null
  
)

export default component.exports